import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center">
      <div className="text-center px-4">
        <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-100">
          <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
        </div>
        <h1 className="text-6xl md:text-8xl font-black font-heading text-background-200 select-none mb-4">
          404
        </h1>
        <h2 className="text-xl font-semibold text-foreground-900 mb-2">页面未找到</h2>
        <p className="text-sm text-foreground-500 mb-6">抱歉，您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}